
    <div [formGroup]="group">
      <label class="radio-label-padding">{{field.label}}:</label>
      <quill-editor [formControlName]="field.name">{{ field.value }}</quill-editor>
      <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
      </ng-container>
    </div>
  